import React from 'react';
import { ProjectLinks, ProjectsCard, ProjectsSection } from '../styled/Projects.styled';
import { Swiper, SwiperSlide } from 'swiper/react';
import { A11y, Navigation, Pagination, Scrollbar, Autoplay, EffectCoverflow } from 'swiper';
import { BsGithub } from 'react-icons/bs';
import { FaLink } from 'react-icons/fa';
import { HiArrowsExpand } from 'react-icons/hi';
// Import Swiper styles
import 'swiper/css';
import { SwiperCard } from './../styled/Projects.styled';
import { projectsData } from '../../data';

const Projects = ({setProject}) => {
    return (
        <ProjectsSection>
            <h4>Projects</h4>
            <ProjectsCard>
                <Swiper modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay, EffectCoverflow]}
                    loop={true}
                    speed={1000}
                    // autoplay={{ delay: 2000 }}
                    effect={'coverflow'}
                    grabCursor={true}
                    centeredSlides={true}
                    slidesPerView={2}
                    spaceBetween={0}
                    coverflowEffect={{
                        "rotate": 50,
                        "stretch": 0,
                        "depth": 10,
                        "modifier": 1,
                        "slideShadows": true,
                        "shadowColor": 'red'
                    }}

                >
                    {projectsData.map((ele,index) => (
                        <SwiperSlide key={index}>
                            <SwiperCard bgImage={ele.image}>
                                <ProjectLinks>
                                    <a rel="noopener noreferrer" target="_blank" href={ele.github}><BsGithub /></a>
                                    <a rel="noopener noreferrer" target="_blank" href={ele.live}><FaLink /></a>
                                    <a rel="noopener noreferrer"  onClick={()=>(setProject(ele))} ><HiArrowsExpand /></a>
                                </ProjectLinks>
                            </SwiperCard>
                        </SwiperSlide>
                    ))}
                    
                </Swiper>
            </ProjectsCard>
        </ProjectsSection>
    );
};

export default Projects;